import { TrackerPosition } from "@/interfaces";

export type IgnitionStatus = "all" | "on" | "off";
export type SpeedRange =
  | "all"
  | "above10"
  | "above20"
  | "above30"
  | "above40"
  | "above50"
  | "above60"
  | "above80"
  | "above100"
  | "above110"
  | "above120"
  | "above130"
  | "above140"
  | "above150"
  | "above160";

export interface PositionsReportTableFilters {
  ignitionStatus: IgnitionStatus;
  speedRange: SpeedRange;
}

const getSpeedThreshold = (speedRange: SpeedRange): number => {
  if (speedRange === "all") return 0;

  const match = speedRange.match(/above(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
};

export const applyFilters = (
  data: TrackerPosition[],
  filters: PositionsReportTableFilters,
) => {
  return data.filter((item) => {
    if (filters.ignitionStatus !== "all") {
      const ignitionOn = filters.ignitionStatus === "on" ? 1 : 0;
      if (item.ignition !== ignitionOn) {
        return false;
      }
    }

    if (filters.speedRange !== "all") {
      const threshold = getSpeedThreshold(filters.speedRange);
      const itemSpeed = item.speed ?? 0;
      if (itemSpeed < threshold) {
        return false;
      }
    }

    return true;
  });
};
